__turbopack_context__.v({
  "action": "room-guide-module__eLLkea__action",
  "guide": "room-guide-module__eLLkea__guide",
  "heading": "room-guide-module__eLLkea__heading",
});
